import reportText from '../../locales/reportTexts.json';
import { FEATURES, getFeatureToggleList } from '../../config/feature.toggles';

export function generateReportLocale({
  dossierType,
  exerciseType
}) {
  const withEF =
    dossierType === 'system' &&
    ['soee', 'moee'].includes(exerciseType);
  const featureList = getFeatureToggleList();

  return {
    DossierPage: reportText.DossierPage,
    LoadingTemplate: reportText.LoadingTemplate,

    SectionSelectorTitle: withEF && featureList[FEATURES.EISM_SECTION]
      ? reportText.SectionSelectorTitle_withEF
      : reportText.SectionSelectorTitle_default,

    SelectorTitles: withEF && featureList[FEATURES.EISM_SECTION]
      ? [...reportText.SelectorTitles_default, reportText.EnvironmentalFootprint]
      : reportText.SelectorTitles_default,

    SelectorSources: [
    {
      key: "details.value",
      type: "dynamicData",
      noDataMsg: "No Section Selectors Data available",
      value: {
        columns: withEF && featureList[FEATURES.EISM_SECTION]  ? reportText.columns_withEF : reportText.columns_default,
        dataset: "com_report_details.csv"
      }
    }
  ],
  hideDisableData: reportText.hideDisableData
  };

}
